export default __webpack_public_path__ + "static/Incorta_White_logo-6dc5a8dd9117de63b55d31f2ae2a3bee.png";